import $ from 'jquery';
window.$ = window.jQuery = $;

// ⚠️ All legacy scripts must be loaded *after* jQuery is global
(async () => {
  await import('jquery-ui');
  await import('underscore');
  await import('bootstrap');
  await import('../../lib/bootstrap-toggle.min');
  await import('../../lib/bootstrap-dropdownhover.min');
  await import('../../theme');
  await import('../../sorting_tables.coffee');
  await import('../../jquery.raty');
  await import('jquery.maskedinput');
  await import('../../ga.coffee');
  await import('../../polls.coffee');
  await import('../../surveys.coffee');
  await import('../../profile_payments.coffee');
  await import('../../bookmakers.coffee');
  await import('../../registration_flow');
  await import('jquery.scrollto');
  await import('jquery.cookie');
  await import('../../lib/jquery.cookie');
  await import('../../lib/userbehavior');
  await import('../../lib/userbehavior-trigger');
  await import('../../button_toggle.coffee');
  await import('local-time');

  $(document).ready(function () {
    if (window.is_blocked_for_russia) {
      $('a.check_for_russia')
        .removeAttr('target')
        .on('click', function () {
          $('.containerForBlockMessage').load('/blocked_page_modal', function () {
            $('.modalBlockPage').modal('show');
          });

          return false;
        });
    }

    $(document).on('click', '.scrollTo', function (e) {
      const target = $(e.target);
      $('body').scrollTo(target.data('scroll'), 500);
      return false;
    });

    $(document).on('click', '.close-btn', function (e) {
      const target = $(e.target);
      target.parents('.message').hide(500);
      return false;
    });
  });
})();
